namespace $.$$ {
	export class $shm_hitalama_text_table_body extends $.$shm_hitalama_text_table_body {
		@ $mol_mem
		view_window( next?: [ number, number ] ): [ number, number ] { return this.$.$shm_hitalama_text_window( this, next ) }
		override sub_visible() { return this.$.$shm_list_sub_visible.call( this ) }
	}
}
